import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import VueRouter from 'vue-router'
import store from './store'



Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VueRouter)



var router = new VueRouter({
  routes: [
    /*Usuario*/

    /*
    {
      path: '/index',
      component: () => import('@/components/user/Index.vue'),
      meta: { 
        requiresAuth: false
      }
    },

    {
      path: '/index_resp',
      component: () => import('@/components/user/Index_resp.vue'),
      meta: { 
        requiresAuth: false
      }
    },





    {
      path: '/vales_gasolina_signature',
      component: () => import('@/components/user/Vales_gasolina_signature.vue'),
      meta: { 
        requiresAuth: false
      }
    },

    {
      path: '/vales_gasolina_consultas',
      component: () => import('@/components/user/Vales_gasolina_consultas.vue'),
      meta: { 
        requiresAuth: false
      }
    },

    {
      path: '/vales_gasolina_personas',
      component: () => import('@/components/user/Vales_gasolina_personas.vue'),
      meta: { 
        requiresAuth: false
      }
    },

        {
      path: '/vales_gasolina_departamentos',
      component: () => import('@/components/user/Vales_gasolina_departamentos.vue'),
      meta: { 
        requiresAuth: false
      }
    },

        {
      path: '/vales_gasolina_vehiculos',
      component: () => import('@/components/user/Vales_gasolina_vehiculos.vue'),
      meta: { 
        requiresAuth: false
      }
    },
*/

/*
    {
      path: '/vales_gasolina_emision_tickets',
      component: () => import('@/components/user/Vales_gasolina_emision_tickets.vue'),
      meta: { 
        requiresAuth: false
      }
    },



    {
      path: '/vales_gasolina_costos',
      component: () => import('@/components/user/Vales_gasolina_costos.vue'),
      meta: { 
        requiresAuth: false
      }
    },



    {
      path: '/vales_gasolina_centros_carga',
      component: () => import('@/components/user/Vales_gasolina_centros_carga.vue'),
      meta: { 
        requiresAuth: false
      }
    },



    {
      path: '/vales_gasolina2',
      component: () => import('@/components/user/Vales_gasolina2.vue'),
      meta: { 
        requiresAuth: false
      }
    },
    

    {
      path: '/genera_vale',
      component: () => import('@/components/user/Genera_vale2.vue'),
      meta: { 
        requiresAuth: false
      }
    },
    */

    {
      path: '/validacion',
      component: () => import('@/components/user/Vales_gasolina.vue'),
      meta: { 
        requiresAuth: false
      }
    },

    {
      path: '/index.html',
      component: () => import('@/components/user/Genera_vale2.vue'),
      meta: { 
        requiresAuth: false
      }
    },



    {
      path: '/login',
      component: () => import('@/components/user/login.vue'),
      meta: { 
        requiresAuth: false
      }
    },



/*

    {
      path: '/genera_vale_borrador',
      component: () => import('@/components/user/Genera_vale2BORRADOR.vue'),
      meta: { 
        requiresAuth: false
      }
    },

*/
  ],
  mode: "history"
});

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
